import React from 'react';
import useTranslation from 'next-translate/useTranslation';

import { Button, OwnPhoneInput, ScreenLoader } from '@/ui/index';
import CountDown from '@/components/common/RecordModal/CountDown';
import useOtpVerification from '@/hooks/useOtpVerification';
import { formatTimer } from '@/utils/formatTimer';

import styles from './PopUpOtp.module.scss';

export const PopUpOtp = () => {
  const {
    isLoading,
    wrongOtp,
    otpRequested,
    otpValue,
    submitHandler,
    handleChangeOtpInput,
    count,
    accountsFetching,
  } = useOtpVerification({ isPopup: true });
  const { t } = useTranslation();
  return (
    <>
      {' '}
      <div
        className={styles.otpVerify}
        itemScope
        itemType='https://schema.org/CheckInAction'
      >
        <ScreenLoader visible={isLoading || accountsFetching} />
        <form className={styles.otpFormWrapper__form} onSubmit={submitHandler}>
          <p className={styles.otpText}>{t('cabinet:common.OTP')}</p>
          <CountDown />
          <OwnPhoneInput
            className={styles.otpInput}
            separationPoints={[]}
            value={otpValue}
            onChange={handleChangeOtpInput}
            placeholder='-'
          />
          {wrongOtp && (
            <p className={styles.wrong_otp}> {t('cabinet:common.WrongOtp')}</p>
          )}
          {otpRequested ? (
            <Button
              variant='outline'
              className={`${styles.button} ${styles.disabled}`}
            >
              {t('cabinet:common.Timer')} : {formatTimer(count)}s
            </Button>
          ) : (
            <Button
              className={`${styles.button} ${styles.resend}`}
              variant='normal'
            >
              {t('cabinet:common.ResendOtp')}
            </Button>
          )}
        </form>
      </div>
    </>
  );
};
